(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/**
 * @module lazyload-videos
 * @summary Lazyload videos
 * @description Load videos and pause them when not in viewport and resume when in viewport again. Set class to ".lazyvideo" to lazyload videos
 *
 * @author Mark Chang
 * @version 1.0.0
 *
 * @example import initLazyloadVideos from "./modules/lazyload-videos";
 */
module.exports = function initLazyloadVideos() {
  /**
   * Helper function
   * Removes multiple attributes from an element
   */
  Element.prototype.removeAttributes = function () {
    var _this = this;

    for (var _len = arguments.length, attrs = new Array(_len), _key = 0; _key < _len; _key++) {
      attrs[_key] = arguments[_key];
    }

    attrs.forEach(function (attr) {
      return _this.removeAttribute(attr);
    });
  };

  var getAllVideoEl = document.querySelectorAll(".lazyvideo");
  var videoObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      var video = entry.target; // Configure the video settings

      if (entry.isIntersecting) {
        console.log("Video is in viewport");
        video.muted = true;
        video.setAttribute("autoplay", "autoplay");
        video.setAttribute("playsinline", "playsinline");
        video.setAttribute("loop", "loop");
        video.removeAttribute("preload");
        video.play();
      } else {
        console.log("Video is not in viewport");
        video.muted = true;
        video.removeAttributes("autoplay", "playsinline", "loop");
        video.setAttribute("preload", "none");
        video.pause();
      }
    });
  }, {
    threshold: 1
  });
  getAllVideoEl.forEach(function (video) {
    videoObserver.observe(video);
  });
};

},{}],2:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _lazyloadVideos = _interopRequireDefault(require("./modules/lazyload-videos"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// Import 3rd party libraries
// ex: import "babel-polyfill";
// global namespace
window.theme = window.theme || {};

theme.initJS = function () {
  // init all modules or functions here
  (0, _lazyloadVideos.default)(); //////////////////////// debugging
};
/**
 * Initialize the productUpsell Container
 *
 * @param {object} upsellContainerParam
 * @returns nothing
 *
 * @author Catalin S.
 */


theme.initProductUpsell = function (upsellContainerParam) {
  // if parameter is empty, then exit code here
  if (upsellContainerParam === null || upsellContainerParam === undefined) return;
  console.log("[DEBUG] Init my Product upsell");
  /**
   * Helper function to assign correct image to variant image
   * @param {array} imagesArr
   * @param {integer} img
   * @param {element} upsellItemEl
   */

  var addVariantImage = function addVariantImage(imagesArr, imageID, upsellItemEl) {
    try {
      imagesArr.forEach(function (image) {
        if (image.id === imageID) {
          // replace src tag with the correct image url
          upsellItemEl.src = image.src;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * Helper function to parse and get product variant data
   * @param {object} product
   * @returns {promise} variantData
   * @author Mark C.
   */


  var getProductVariantData = function getProductVariantData(product) {
    return new Promise(function (resolve, reject) {
      // if the product is not found, then exit code here
      if (product === null) {
        reject("Product not found");
      } else {
        // fetch product data
        fetch("/products/" + product.handle + ".json").then(function (response) {
          return response.json();
        }).then(function (productData) {
          var productVariantsArray = productData.product.variants;
          var productImagesArray = productData.product.images; // if the product has variants

          if (productVariantsArray.length > 1) {
            // loop through the variants
            productVariantsArray.forEach(function (variant) {
              // if the variant is the same as the upsell product SKU
              if (variant.sku === upsellProductSKU) {
                // add the correct image to the upsell image
                addVariantImage(productImagesArray, variant.image_id, $upsellItemImage); // resolve the promise

                resolve(variant);
                console.log(productVariantsArray);
              }
            });
          } else {
            // if the product has no variants, then add the first image to the upsell image
            addVariantImage(productImagesArray, productImagesArray[0].id, $upsellItemImage); // resolve the promise

            resolve(productVariantsArray[0]);
          }
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  }; // function to generate unique ID on every call to the function using the Date.now() function in milliseconds and random number


  var generateUniqueID = function generateUniqueID() {
    return Date.now() + Math.random();
  };
  /**
   * Definition of the Product Upsell Container selectors
   */


  var $upsellContainer = upsellContainerParam; // if the container element exists

  if ($upsellContainer === null) return; // Retrieve the product upsell data from the DOM

  var upsellSearchKey = $upsellContainer.dataset.searchkey;
  var upsellCurrentProductHandle = $upsellContainer.dataset.handle;
  var upsellProductSKU = $upsellContainer.dataset.upsellsku; // Define the upsell container selectors

  var $upsellItemImage = $upsellContainer.querySelector(".item--image");
  var $upsellItemTitle = $upsellContainer.querySelector(".item--title");
  var $upsellItemPrice = $upsellContainer.querySelector(".item--price"); // ToDo: add click event to the element to add the product to the cart

  var $clickHandlerEl = $upsellContainer.querySelector(".js-product-upsell__check");
  var upsellFormData = {
    items: []
  }; // define the search query parameters

  var query = upsellSearchKey + "&resources[type]=product&resources[limit]=2&resources[options][fields]=tag"; // fetch the upsell data from the API

  fetch("/search/suggest.json?q=" + query).then(function (response) {
    return response.json();
  }).then(function (suggestions) {
    var productSuggestions = suggestions.resources.results.products;
    var deleteVariantID; // loop over productSuggestions object

    productSuggestions.forEach(function (product) {
      // If current handle equals the product handle
      if (product.handle !== upsellCurrentProductHandle) {
        // get the product variant data
        var variantData = getProductVariantData(product); // process the variant data promise

        variantData.then(function (variant) {
          // assign data from variant object to const
          var variantPrice = variant.price;
          var variantTitle = variant.title; // add data to the element

          $upsellItemTitle.innerHTML = variantTitle;
          $upsellItemPrice.innerHTML = variantPrice;
          $upsellContainer.dataset.variantid = variant.id; // ToDo: show upsell container

          $upsellItemImage.style.display = "block";
          $upsellContainer.classList.remove("skeleton-load");
          var newItem = {
            id: variant.id,
            quantity: 1
          };
          deleteVariantID = variant.id; // fill the empty objects with the current form data

          upsellFormData.items.push(newItem);
          console.log("Add Items Object are filled", upsellFormData);
        }).catch(function (error) {
          console.log(error);
        });
        $clickHandlerEl.addEventListener("click", function () {
          // states active / inactive states of element
          $clickHandlerEl.classList.toggle("active"); // if state is default

          if ($clickHandlerEl.classList.contains("active")) {
            theme.postUpsellItemToCart(upsellFormData);
            console.log("[DEBUG] Upsell item added to cart", upsellFormData);
          } else {
            // else if is active then write postUpsell remove
            theme.removeUpsellItemFromCart(deleteVariantID);
            console.log("[DEBUG] Upsell item removed from cart", deleteVariantID);
          } // add / remove

        });
      }
    });
  }).catch(function (error) {
    console.log(error);
  });
};
/**
 * Post Item to the ajax cart API
 * Accepts postMethod parameter to determine if "update" or "add"
 *
 * @param {object} formObj
 * @param {string} postMethod
 *
 * @author Catalin S.
 */


theme.postUpsellItemToCart = function (formObj) {
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formObj)
  }).then(function (response) {
    console.log(response);
    theme.updateCart();
    return response.json();
  }).catch(function (error) {
    console.error("Error:", error);
  });
};
/**
 * Remove Item from the ajax cart API
 */


theme.removeUpsellItemFromCart = function (variantID) {
  if (variantID === null) return;
  $.ajax({
    method: "POST",
    url: window.Shopify.routes.root + "cart/change.js",
    async: false,
    data: {
      quantity: 0,
      id: variantID
    },
    success: function success(data) {
      console.log("Sucess", data);
    },
    complete: function complete(data) {
      theme.updateCart();
    }
  });
};
/**
 * Update Cart function
 * Triggers the cart update function, and re-renders the ajax.cart modal
 */


theme.updateCart = function () {
  console.log("Updated");
  $.get(window.Shopify.routes.root + "cart?view=ajax", function (data) {
    $(".cart-popup").html(data);
    var cart_count = parseInt($(".cart-popup__item_count").text().replace("(", "").replace(")", ""));
    $(".cart-count").text(cart_count);

    if (cart_count == 0) {
      $(".cart-count").removeClass("cart-count--active");
    } else {
      if (!$(".cart-count").hasClass("cart-count--active")) {
        $(".cart-count").addClass("cart-count--active");
      }
    }

    if (!$(".cart-popup").hasClass("active")) {
      if (!$(".header__icons .cart-icon").hasClass("active")) {
        $(".header__icons .cart-icon").addClass("active");
        setTimeout(function () {
          $(".header__icons .cart-icon").removeClass("active");
        }, 5000);
      }
    }

    if (!$(".cart-popup").hasClass("active")) {
      setTimeout(function () {
        $(".cart-popup").addClass("active");
      }, 500);
    }
  });
};
/**
 * Fetches the Ajax cart drawer template and renders it
 * @returns {Promise<void>}
 * @author Catalin G.
 */


theme.renderDrawer = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var response, drawerTemplate, parser, drawerHTMLTemplate, mainEl, drawerEl;
  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("".concat(window.Shopify.routes.root, "cart?view=ajax"));

        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.text();

        case 6:
          drawerTemplate = _context.sent;
          parser = new DOMParser(); // Parse the response as HTML

          drawerHTMLTemplate = parser.parseFromString(drawerTemplate, "text/html"); // Get the "main" DOM element

          mainEl = document.querySelector('main[role="main"]'); // Select every drawer on the page

          drawerEl = mainEl.querySelectorAll('.cart-popup'); // Check if the drawer is already in the DOM

          if (!(drawerEl.length > 0)) {
            _context.next = 13;
            break;
          }

          return _context.abrupt("return");

        case 13:
          // Prepend the drawer content to the "main" DOM element
          mainEl.prepend.apply(mainEl, _toConsumableArray(drawerHTMLTemplate.body.children));
          _context.next = 19;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[0, 16]]);
}));

theme.initAccordion = function () {
  var accordionToggles = document.querySelectorAll('[data-accordion]');
  if (!accordionToggles.length > 0) return;
  accordionToggles.forEach(function (accordion) {
    var label = accordion.querySelector('span').textContent;
    var attribute = label.replace(new RegExp(' ', 'g'), '-').replace(/,/g, '').toLowerCase();
    accordion.setAttribute('data-nested-control', attribute);
    var panel = accordion.nextElementSibling;
    panel.setAttribute('data-nested-content', attribute);
  });
  accordionToggles.forEach(function (accordion) {
    accordion.addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var content = btn.nextElementSibling;
      var expanded = btn.getAttribute('aria-expanded');

      if (expanded === 'false') {
        btn.classList.add('active');
        content.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.classList.remove('active');
        content.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
};
/**
 * Custom DOMready function
 * @param {*} callback
 */


theme.DOMready = function (callback) {
  if (document.readyState !== 'loading') callback();else document.addEventListener('DOMContentLoaded', callback);
};
/**
 * Use this event listener to run your JS after the DOM is ready
 */


theme.DOMready(function () {
  // Init Main JS
  theme.initJS(); // dispatch customEvent

  console.log("[DEBUG] Emit page:loaded event");
  document.dispatchEvent(new CustomEvent('page:loaded'));
  theme.renderDrawer();
  theme.initAccordion();
});

},{"./modules/lazyload-videos":1}]},{},[2])

